import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BorrowerApi } from '@sg/api/borrower-api';
import { SgEntityBasedSession } from '../../misc';

@Component({
  selector: 'sg-borrower-entity-select',
  templateUrl: './entity-select.component.html',
  styleUrls: ['./entity-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgBorrowerEntitySelectComponent {
  @Input() availabilitySplit: BorrowerApi.AvailabilitySplitDto[];
  @Input() disabled: boolean;
  @Input() session: SgEntityBasedSession;
  @Output() selectionChange: EventEmitter<BorrowerApi.AvailabilitySplitDto> = new EventEmitter();
  legalEntity = new FormControl<any>('');

  ngOnChanges(changes: SimpleChanges): void {
    if ('availabilitySplit' in changes) {
      this.selectDefaultLegalEntity();
    }
    if ('disabled' in changes && this.disabled) {
      this.legalEntity.disable();
    }
  }

  private selectDefaultLegalEntity(): void {
    let defaultLegalEntityIndex = 0;
    if (this.session?.user?.userSettings?.defaultLegalEntity) {
      const legalEntityIndex = this.availabilitySplit.findIndex(
        (x) => x.borrowerId === this.session.user.userSettings.defaultLegalEntity
      );
      if (legalEntityIndex !== -1) {
        defaultLegalEntityIndex = legalEntityIndex;
      }
    }
    const defaultMatchUnits = this.availabilitySplit[defaultLegalEntityIndex];
    this.legalEntity.setValue(defaultMatchUnits);
    this.selectionChange.emit(defaultMatchUnits);
  }
}
